module.exports = __webpack_public_path__ + "static/media/7.1e344bc1.svg";